<template>
  <v-snackbar
    v-model="visible"
    :timeout="-1"
    bottom
    right
    class="call-center-idle-snackbar ml-4"
    color="#c05415"
    elevation="24"
    dir="rtl"
  >
    <div class="call-center-idle-snackbar__content">
      <v-icon small color="white" class="ml-2">mdi-phone-off</v-icon>
      <span>{{ message }}</span>
    </div>
    <template v-slot:action="{ attrs }">
      <v-btn icon small v-bind="attrs" @click="dismiss">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { axiosInstance } from "@/axios/config";

const POLL_MS = 60 * 60 * 1000; //Polls every hour
const INITIAL_DELAY_MS = 15 * 1000; //(first check after 15 seconds)
const CHECK_HOURS = 60;
export default {
  name: "CallCenterIdleAlert",
  data() {
    return {
      visible: false,
      message: "",
      pollHandle: null,
      initialHandle: null,
      dismissedUntil: 0,
      lastAlertedMinutes: 0,
      thresholdMinutes: 30,
    };
  },
  mounted() {
    // console.log('mounted called');
    if (!this.isAdminUser()) {
      return;
    }

    this.initialHandle = setTimeout(() => {
      // console.log('initialHandle called');
      this.checkIdleStatus();
      this.pollHandle = setInterval(this.checkIdleStatus, POLL_MS);

      console.log('POLL_MS', POLL_MS);
    }, INITIAL_DELAY_MS);
  },
  beforeDestroy() {
    if (this.initialHandle) {
      clearTimeout(this.initialHandle);
    }
    if (this.pollHandle) {
      clearInterval(this.pollHandle);
    }
  },
  methods: {
    isAdminUser() {
      return (
        localStorage.getItem("isAdmin") === "true" ||
        String(localStorage.getItem("role")) === "7"
      );
    },
    checkIdleStatus() {
      // console.log('checkIdleStatus called');
      if (!this.isAdminUser()) {
        return;
      }

      axiosInstance
        .get("/employee/admin/call-center-queues/idle-status")
        .then((res) => {
          this.handleStatus(res.data.payload || {});
        })
        .catch(() => {});
    },
    handleStatus(payload) {
      // console.log('handleStatus called');
      // console.log('payload', payload);

      this.thresholdMinutes = payload.threshold_minutes || 30;

      if (!payload.enabled || !payload.is_idle) {
        // console.log('payload.enabled', payload.enabled);
        this.visible = false;
        this.lastAlertedMinutes = 0;
        this.dismissedUntil = 0;
        return;
      }

      if (Date.now() < this.dismissedUntil) {
        // console.log('dismissedUntil', this.dismissedUntil);
        return;
      }

      // console.log('lastAlertedMinutes', this.lastAlertedMinutes);
      // console.log('-------------------------');
      const minutes = payload.minutes_since_last_call || 0;

      // console.log('minutes', minutes);
      // console.log('thresholdMinutes', this.thresholdMinutes);
      // console.log('minutes - lastAlertedMinutes', minutes - this.lastAlertedMinutes);
      
      const shouldAlert =
        this.lastAlertedMinutes === 0 ||
        (minutes - this.lastAlertedMinutes) >= CHECK_HOURS;

      if (!shouldAlert) {
        return;
      }

      this.message = this.buildMessage(minutes, payload.last_call_at);
      this.visible = true;
      this.lastAlertedMinutes = minutes;
    },
    buildMessage(minutes, lastCallAt) {
      const lastCallText = lastCallAt
        ? `آخر مكالمة: ${lastCallAt}`
        : "لم يتم تسجيل مكالمات بعد";

      return `تنبيه: لم يتم تسجيل أي مكالمة في الكول سنتر منذ ${minutes} دقيقة (الحد: ${this.thresholdMinutes} دقيقة). ${lastCallText}`;
    },
    dismiss() {
      this.visible = false;
      this.dismissedUntil = Date.now() +   60 * 1000;
      // console.log('dismissedUntil', this.dismissedUntil);//1783527788698
    },
  },
};
</script>

<style scoped>
.call-center-idle-snackbar__content {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.5;
  max-width: 420px;
}
</style>

<style>
.call-center-idle-snackbar {
  z-index: 1006 !important;
}

.dark .call-center-idle-snackbar .v-snack__wrapper {
  border: 1px solid rgba(255, 183, 77, 0.35);
}
</style>
